import { elsewhereKeys } from './constants'

import { createEventEmitter } from '../event'

export const elsewhereEventEmitter = createEventEmitter()

export const emitElsewhereMessage = msg => {
    elsewhereEventEmitter.emit(elsewhereKeys.ELSEWHERE, msg)
}
